import React, { useCallback } from 'react';
import { useCalculationEdit } from './useCalculationEdit';
import { IconButton, IconButton_IconSizes } from '@ydistri/ds';

import { MdBackup, MdDifference } from 'react-icons/md';
import { AvailableModals, openModal } from '../../Modals/modalSlice';
import { useAppDispatch } from '../../../store';
import { useTheme } from 'styled-components';

const backupIcon = <MdBackup size={IconButton_IconSizes.small} />;
const changesIcon = <MdDifference size={IconButton_IconSizes.small} />;

interface EditRedistributionStatusButtonsProps {
  calculationId: number;
}

const EditRedistributionStatusButtons: React.FC<EditRedistributionStatusButtonsProps> = ({
  calculationId,
}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { isBackedUp, isSkuRedistributionEdited, isSuperUser, isSubmerged } =
    useCalculationEdit(calculationId);

  const onClickHandler = useCallback(() => {
    dispatch(
      openModal({
        type: AvailableModals.SKU_REDISTRIBUTION_CHANGELOG,
        data: { calculationId },
      }),
    );
  }, [dispatch, calculationId]);

  return (
    <>
      {isBackedUp && isSuperUser && (
        <IconButton
          colorScheme={theme.iconColorSchemes.ghost}
          size="small"
          tooltip="Redistribution is backed up"
          icon={backupIcon}
        />
      )}
      {isSkuRedistributionEdited && (
        <IconButton
          size="small"
          tooltip={
            isSubmerged
              ? 'Go to main calculation to see changes.'
              : 'See changes made in redistribution'
          }
          icon={changesIcon}
          onClick={onClickHandler}
          disabled={isSubmerged}
        />
      )}
    </>
  );
};

export default EditRedistributionStatusButtons;
